<template>
  <div id="app">
    <UserInfo :userInfo="userInfo" :cusMadeBlinds="cusMadeBlinds" 
    :cusMadeCurtains="cusMadeCurtains" :readyMadeCurtains="readyMadeCurtains"></UserInfo>
    <div class="hidden-sm-and-down">
      <CusMadeBlinds :cusMadeBlinds="cusMadeBlinds" :options="options"></CusMadeBlinds>
       <CusMadeCurtains :cusMadeCurtains="cusMadeCurtains" :options="options"></CusMadeCurtains>
       <ReadyMadeCurtains :readyMadeCurtains="readyMadeCurtains" :options="options"></ReadyMadeCurtains>
    </div>

    <div class="hidden-md-and-up">
      <el-collapse v-model="activeName" accordion>
  <el-collapse-item name="1">
    <template slot="title">
      <h3>Custom Made Blinds</h3>
    </template>
     <CusMadeBlinds :cusMadeBlinds="cusMadeBlinds" :options="options"></CusMadeBlinds>
  </el-collapse-item>
  <el-collapse-item name="2">
     <template slot="title">
      <h3>Custom Made Curtains</h3>
    </template>
    <CusMadeCurtains :cusMadeCurtains="cusMadeCurtains" :options="options"></CusMadeCurtains>
  </el-collapse-item>
  <el-collapse-item name="3">
     <template slot="title">
      <h3>Ready Made Curtains</h3>
    </template>
    <ReadyMadeCurtains :readyMadeCurtains="readyMadeCurtains" :options="options"></ReadyMadeCurtains>
  </el-collapse-item>
</el-collapse>
    </div>
   
   
  </div>
</template>

<script>
import UserInfo from "@/components/UserInfo";
import CusMadeBlinds from "@/components/CusMadeBlinds";
import CusMadeCurtains from "@/components/CusMadeCurtains";
import ReadyMadeCurtains from "@/components/ReadyMadeCurtains";
import { getCurtainCustomerId } from "@/api/GetCurtainCustomerId";
import { getCurtainQuoationId } from "@/api/GetCurtainQuoationId";
import { loadDataFromFile } from "@/api/LoadDataFromFile";
export default {
  name: "App",
  components: { UserInfo, CusMadeBlinds, CusMadeCurtains, ReadyMadeCurtains },
  data() {
    return {
      userInfo: {
        Name: "",
        PhoneNumber: "",
        Address: "",
        Email: ""
      },
      cusMadeBlinds: [
        {
          CurtainId: "",
          Window: "",
          Type: "",
          Drop: null,
          Width: null,
          Fabric: "",
          Price: 0,
          Saved: "el-icon-close"
        }
      ],
      cusMadeCurtains: [
        {
          CurtainId: "",
          Window: "",
          Type: "",
          Drop: null,
          Width: null,
          Fabric: "",
          Lining: "",
          Sheer: "",
          Price: 0,
          Saved: "el-icon-close"
        }
      ],
      readyMadeCurtains: [
        {
          CurtainId: "",
          Window: "",
          Size: "",
          Fabric: "",
          Price: 0,
          Saved: "el-icon-close"
        }
      ],
      activeName: "1",
      options: []
    };
  },
  created() {
    this.$nextTick(() => {
      loadDataFromFile()
        .then(res => {
          this.options = res.data;
        })
        .catch(err => {
          this.$message.error("something wrong when get the data:" + err);
        });
    });
    if (!localStorage.getItem("curtain_customerId")) {
      this.$nextTick(() => {
        getCurtainCustomerId()
          .then(res => {
            localStorage.setItem("curtain_customerId", res.data);
          })
          .catch(err => {
            this.$message.error("something wrong when get the data:" + err);
          });
      });
    }
    // 判断localstorage 里是否有quotationID
    //     if(!localStorage.getItem('curtain_quoationId')){
    //         this.$nextTick(() => {
    //              getCurtainQuoationId()
    //          .then(res => {
    //            localStorage.setItem('curtain_quoationId',res.data)
    //            })
    //          .catch(err => {
    //         this.$message.error("something wrong when get the data:" + err);
    //     });
    // });
    //  };
    this.$nextTick(() => {
      getCurtainQuoationId()
        .then(res => {
          localStorage.setItem("curtain_quoationId", res.data);
        })
        .catch(err => {
          this.$message.error("something wrong when get the data:" + err);
        });
    });

    this.$store.commit("resetState");
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue